import { ref, watch } from 'vue'
import { useSalesReportsStore } from '../stores/salesReports'

/**
 * Shared state for desktop report navigation between
 * GlobalDesktopSidebar and ReportDesktopShell.
 *
 * Uses module-level refs so every consumer sees the same values.
 */
const _activeSrIndex = ref(0)
const _showCreateSheet = ref(false)

export function useDesktopReportNav() {
  const salesReportsStore = useSalesReportsStore()

  // Reset index when the report list changes (center switch)
  watch(
    () => salesReportsStore.salesReports,
    (reports) => {
      if (!reports || _activeSrIndex.value >= reports.length) {
        _activeSrIndex.value = 0
      }
    },
  )

  return {
    activeSrIndex: _activeSrIndex,
    showCreateSheet: _showCreateSheet,
    resetToFirst: () => { _activeSrIndex.value = 0 },
  }
}
